import CheckIcon from "@/assets/svgs/CheckIcon";
import { Typography } from "@graphy/ui";
import Image, { StaticImageData } from "next/image";
import SectionHeading, { SectionHeadingType } from "../atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type PlatformMigrationBannerPropsType = {
  title: SectionHeadingType;
  features: string[];
  ctas: CtaType[];
  description: string;
  image: {
    src: StaticImageData;
    alt: string;
  };
  footerText?: string;
};

const PlatformMigrationBanner = ({
  title,
  features,
  ctas,
  description,
  image,
  footerText,
}: PlatformMigrationBannerPropsType) => {
  return (
    <div className="w-full flex justify-center items-center bg-[#F8F8FC]">
      <div className="page-max-width mx-0 flex flex-col justify-between gap-4 px-4 py-2 md:mx-auto md:flex-row md:items-center md:px-0 md:py-6">
        {/* Left: Text */}
        <div className="flex-1 flex flex-col gap-4 h-full justify-between">
          <SectionHeading heading={title} key={"product-statsCards-heading"} />
          <Typography
            fontSize="text-title6"
            fontWeight="font-normal"
            colorClass="text-grey-4"
            className="mt-[6px]"
          >
            {description}
          </Typography>
          <div className="mb-2 mt-2 flex flex-col gap-2 md:my-3">
            {features.map((feature, index) => {
              return (
                <div key={feature} className="flex items-center gap-3">
                  <span className="h-5 w-5 text-purple-500 flex items-center justify-center">
                    <CheckIcon />
                  </span>
                  <p className="text-body-12 font-normal text-grey-4 ">{feature}</p>
                </div>
              );
            })}
          </div>
          <div className="mt-2">
            <CtaButtonGroup ctas={ctas} gap="gap-4" fullWidthOnMobile={false} />
          </div>
          {footerText && (
            <div className="mt-6 max-w-[580px] w-full text-left">
              <Typography
                fontSize="text-body"
                colorClass="text-grey-4"
                fontWeight="font-normal"
                align="text-left"
                className="!mb-0 !mt-0"
              >
                {footerText}
              </Typography>
            </div>
          )}
        </div>
        {/* Right: Image in white box */}
        <div className="flex-1 flex justify-center items-center mt-4 md:mt-0 h-full">
          <div className="bg-white rounded-2xl border border-grey-2 flex justify-center items-center w-full max-w-[580px] h-full">
            <Image
              src={image?.src!}
              alt={image?.alt!}
              width={580}
              height={532}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformMigrationBanner;
